import { StrictMode } from "react";
import ReactDOM from "react-dom";
import { HashRouter } from "react-router-dom";
import { Web3ReactProvider, createWeb3ReactRoot } from "@web3-react/core";
import { Web3Provider } from "@ethersproject/providers";
import { NetworkContextName } from "./constants/misc";
import ThemeProvider, { FixedGlobalStyle, StyledToastContainer, ThemedGlobalStyle } from "./theme";
import App from "./pages/App";
import { ApolloClient, ApolloProvider, InMemoryCache } from "@apollo/client";
import { ToastContainer } from "react-toastify";

const Web3ProviderNetwork = createWeb3ReactRoot(NetworkContextName);

function getLibrary(provider) {
	const library = new Web3Provider(provider);
	library.pollingInterval = 12000;
	return library;
}

export const client = new ApolloClient({
	uri: "https://api.thegraph.com/subgraphs/name/uniswap/uniswap-v2",
	cache: new InMemoryCache(),
});

ReactDOM.render(
	<StrictMode>
		<ThemeProvider>
			<FixedGlobalStyle />
			<ThemedGlobalStyle />
			<HashRouter>
				<Web3ReactProvider getLibrary={getLibrary}>
					<Web3ProviderNetwork getLibrary={getLibrary}>
						<ApolloProvider client={client}>
							<StyledToastContainer />
							<App />
						</ApolloProvider>
					</Web3ProviderNetwork>
				</Web3ReactProvider>
			</HashRouter>
		</ThemeProvider>
	</StrictMode>,
	document.getElementById("root")
);
